import { render, staticRenderFns } from "./EditTransform.vue?vue&type=template&id=7214f5e8&lang=pug&"
import script from "./EditTransform.vue?vue&type=script&lang=js&"
export * from "./EditTransform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports